import React from 'react'
import { styled } from '@mui/material/styles'

const HeaderSpaceDiv = styled('div')(({ theme }) => ({
    ...theme.mixins.header,
}))

export default function HeaderSpace() {
    return <HeaderSpaceDiv />
}
